import { Injectable } from '@angular/core';
import { EntityState, StoreConfig, Store } from '@datorama/akita';
import { AutoTopUpSubscriptionModel } from './models/auto-top-up-subscription.model';

export interface AutoTopupState extends EntityState<AutoTopUpSubscriptionModel> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'auto-topup' })
export class AutoTopupStore extends Store<AutoTopUpSubscriptionModel> {

  constructor() {
    super({});
  }

}

